export const ROLES = [
  { id: 1, label: "Administrateur", badge: "red" },
  { id: 2, label: "Utilisateur", badge: "blue" },
  { id: 3, label: "Association", badge: "green" },
];